// CONTEXTS
import { CustomersProvider } from "../../contexts/customers/customers.context";
// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import StatementPage from "../statements/page.statement.page";

const StatementsLayout = () => {
  return (
    <LoggedIn>
      <CustomersProvider>
           <StatementPage />
      </CustomersProvider>
    </LoggedIn>
  );
};

export default StatementsLayout;
